/* Type, Constants, Utils */
import * as Constants from "../constants";

/* Redux */
import {useDispatch} from "react-redux";

import {
  searchReset,
  setDBSet,
  setFiltersKey, setQuery, setSort
} from "../redux/slices/search-slice";
import {clearFacets, clearSelectedResults, resetResults} from "../redux/slices/result-slice";
import {Dispatch} from "react";
import {AnyAction} from "@reduxjs/toolkit";
import SearchUtils from "../utils/search-utils";

const useSearchReset = (): Function => {
  const dispatch:Dispatch<AnyAction> = useDispatch();

  return (dbSet:string | null): void => {
    dispatch(setQuery({query: [Constants.DEFAULT_SEARCH], recent_query: false}))
    dispatch(setDBSet(dbSet)); // filter reset may be dependent on if content page or not
    dispatch(searchReset())
    if (dbSet) {
      dispatch(setSort(SearchUtils.sortDefault(window.location.search))); // reset to default filters
    }
    dispatch(resetResults());
    dispatch(clearFacets());
    dispatch(clearSelectedResults());
    dispatch(setDBSet(dbSet)); // search resets dbSet to default so have to reset it
    dispatch(setFiltersKey(dbSet ? dbSet : Constants.DOCUMENTS))
  }
};

export default useSearchReset;
